import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import SearchClients from "../pages/Clients/Search/SearchClients";
import PrivateRoute from "./PrivateRoutes";
import NewClients from "../pages/Clients/New/NewClients";
import NewAcoustic from "../pages/Acoustic/New/AcousticNew";
import ListAcoustic from "../pages/Acoustic/List/AcousticList";
import Callback from "../services/Callback";
import { useGetDynamicReportingMenu } from "../hooks/PowerBI";
import ReportingDataviz from "../pages/ReportingDataViz";
import Settings from "../pages/Settings/Settings";

// Marketing
import Calendar from "../pages/Marketing/Calendar";
import NewAnimation from "../pages/Marketing/NewAnimation";
import Preconizations from "../pages/Marketing/Preconizations";
import AdvancedSearch from "../pages/Marketing/AdvancedSearch";
import Library from "../pages/Marketing/Library";
import RecurringOffer from "../pages/Marketing/RecurringOffer";
import CustomerJourney from "../pages/Marketing/CustomerJourney";
import Timeslots from "../pages/Marketing/Timeslots";
import Drafts from "../pages/Marketing/Drafts";

// Clients
import TargettingAndExtractFiles from "../pages/Clients/TargettingAndExtractFiles";
import ListImport from "../pages/Clients/ListImport";
import CustomerDashboard from "../pages/Clients/Dashboard/CustomerDashboard";

// Store
import AddNewStore from "../pages/Store/AddNewStore";
import ShowStore from "../pages/Store/ShowStore";
import UpdateStore from "../pages/Store/UpdateStore";

// Acoustic
import OfferRequestDetails from "../pages/Acoustic/OfferRequestDetails";
import Profile from "../pages/Profile/Profile";

const AppRouter = (): React.ReactElement => {
  // Hook to get dynamic Power BI menu configuration
  const { reportingMenuItems, loading: loadingReporting } = useGetDynamicReportingMenu();

  // Generate dynamic routes from Power BI menu data
  const generateDynamicPowerBIRoutes = () => {
    if (!reportingMenuItems || !reportingMenuItems.children) {
      return null;
    }

    const routes: React.ReactElement[] = [];

    reportingMenuItems.children.forEach((block) => {
      if (block.children) {
        block.children.forEach((report) => {
          if (report.path) {
            // Extract the report key from path (last segment)
            const reportKey = report.path.split('/').pop() || '';
            routes.push(
              <Route
                key={report.path}
                path={report.path}
                element={<ReportingDataviz labelReport={reportKey} />}
              />
            );
          }
        });
      }
    });

    return routes;
  };

  return (
    <Router>
      <Routes>
        {/* Route publique */}
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />

        {/* Routes protégées - Toutes avec le même layout */}
        <Route element={<PrivateRoute />}>
          {/* Dashboard principal */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          
          {/* Marketing */}
          <Route path="/marketing/calendar" element={<Calendar />} />
          <Route path="/marketing/new-animation" element={<NewAnimation />} />
          <Route path="/marketing/preconizations" element={<Preconizations />} />
          <Route path="/marketing/advanced-search" element={<AdvancedSearch />} />
          <Route path="/marketing/library" element={<Library />} />
          <Route path="/marketing/drafts" element={<Drafts />} />
          <Route path="/marketing/recurring-offer" element={<RecurringOffer />} />
          <Route path="/marketing/customer-journey" element={<CustomerJourney />} />
          <Route path="/marketing/timeslots" element={<Timeslots />} />
          
          {/* Dynamic Power BI Routes - Generated from API */}
          {generateDynamicPowerBIRoutes()}
          
          {/* Clients */}
          <Route path="/clients/new" element={<NewClients />} />
          <Route path="/clients/search" element={<SearchClients />} />
          <Route path="/clients/dashboard/:personId" element={<CustomerDashboard />} />
          <Route path="/clients/dashboard" element={<CustomerDashboard />} />
          <Route path="/clients/query-builder" element={<Navigate to="/clients/targetting-extract-files" replace />} />
          <Route path="/clients/targetting-extract-files" element={<TargettingAndExtractFiles />} />
          <Route path="/clients/list-import" element={<ListImport />} />
          
          {/* Store */}
          <Route path="/store/add-new-store" element={<AddNewStore />} />
          <Route path="/store/show-store" element={<ShowStore />} />
          <Route path="/store/update-store" element={<UpdateStore />} />
          
          {/* Acoustic */}
          <Route path="/acoustic/new" element={<NewAcoustic />} />
          <Route path="/acoustic/search" element={<ListAcoustic />} />
          <Route path="/acoustic/offer-request-details" element={<OfferRequestDetails />} />
        </Route>

        {/* Redirection par défaut */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
